import { render } from "./Login.vue?vue&type=template&id=4b50f35e&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "@/assets/scss/_login.scss?vue&type=style&index=0&id=4b50f35e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b50f35e"]])

export default __exports__